module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-bored.fe521791.png";